<template>

    <div class="container">

        <div class="handle-box-search">





            <el-row class="head-search">


                <el-col :span="18">
                    <span class="title">时间:</span>

                        <el-radio-group
                                v-model="complete_fixed_time_value"
                                size="small"
                                @change="completeFixedTimeChange"
                        >
                            <el-radio-button label="yesterday" border>昨天</el-radio-button>
                            <el-radio-button label="this_week" border>本周</el-radio-button>
                            <el-radio-button label="last_week" border>上周</el-radio-button>
                            <el-radio-button label="this_month" border>本月</el-radio-button>
                            <el-radio-button label="last_month" border>上月</el-radio-button>
                            <el-radio-button label="between" border
                            >自定义时间</el-radio-button
                            >
                        </el-radio-group>




                        <el-date-picker
                                v-if="complete_fixed_time_value == 'between'"
                                v-model="complete_time_arrway"
                                type="datetimerange"
                                range-separator="-"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                @change="timeChange()"
                        >
                        </el-date-picker>




                </el-col>

                <el-col :span="4" style="margin-left: 20px">
                    <el-button type="primary" icon="el-icon-search" @click="searchgetFinancialAmount">搜索</el-button>
<!--                    <el-button :icon="!progress_show?'el-icon-setting':'el-icon-loading'" @click="toExport" :disabled="progress_show">{{progress_show?'正在导出...':'导出'}}</el-button>-->
                </el-col>



            </el-row>



        </div>

        <div class="main fir">
            <!-- <div class="title blue">
                <h4>拉卡拉打款相关费用</h4>
                <p>总金额 <span>￥{{tableData.total_amount}}</span> </p>
            </div> -->

            <!-- <div class="item-row">
                <div>
                    <h5>￥{{tableData.total_all_driver_amount}}</h5>
                    <p>代驾费用</p>
                </div>
                <div>
                    <h5>￥{{tableData.total_inspection_amount}}</h5>
                    <p>检车费用</p>
                </div>

                <div>
                    <h5>￥{{tableData.total_all_legwork_amount}}</h5>
                    <p>跑腿费用</p>
                </div>
                <div>
                    <h5>￥{{tableData.total_driver_wallet_amount}}</h5>
                    <p>司机充值</p>
                </div>
            </div> -->
            <div class="item-row">
                <div style="background-color: #D3F3FB;border-radius: 10px 0 0 10px;">
                    <h5>￥{{tableData.total_all_active_amount}}</h5>
                    <p>活动费用</p>
                </div>
                <div style="background-color: #E8F9FD">
                    <h5>￥{{tableData.all_active_amount.total_scan_amount}}</h5>
                    <p>司机推广-收入</p>
                </div>
                <div style="background-color: #E8F9FD">
                    <h5>￥{{tableData.all_active_amount.total_scan_bear_amount}}</h5>
                    <p>司机推广-支出</p>
                </div>
                <div style="background-color: #E8F9FD">
                    <h5>￥{{tableData.all_active_amount.total_position_amount}}</h5>
                    <p>地图红包</p>
                </div>
                <!-- <div style="background-color: #E8F9FD">
                    <h5>￥{{tableData.all_active_amount.total_deduct_bear_amount}}</h5>
                    <p>余额支付-司机承担</p>
                </div> -->
                <div style="background-color: #E8F9FD;border-radius: 0 10px 10px 0;">
                    <h5>￥{{tableData.all_active_amount.total_exchange_bear_amount}}</h5>
                    <p>用户拉新-司机承担</p>
                </div>
            </div>

        </div>


        <!-- <div class="main sec">
            <div class="title">
                <h4>代驾订单相关费用汇总</h4>
                <p>总金额 <span>￥{{tableData.total_all_driver_amount}}</span> </p>
            </div>

            <div class="item-row">
                <div>
                    <h5>￥{{tableData.all_driver_amount.total_coin_amount}}</h5>
                    <p>耿师傅币支付金额</p>
                </div>
                <div>
                    <h5>￥{{tableData.all_driver_amount.total_coupon_all_amount}}</h5>
                    <p>优惠券支付金额(全额抵扣)</p>
                </div>

                <div>
                    <h5>￥{{tableData.all_driver_amount.total_coupon_online_amount}}</h5>
                    <p>优惠券支付金额(部分抵扣)</p>
                </div>
                <div>
                    <h5>￥{{tableData.all_driver_amount.total_real_amount}}</h5>
                    <p>线上支付金额</p>
                </div>
                <div>
                    <h5>￥{{tableData.all_driver_amount.total_price_amount}}</h5>
                    <p>余额支付(现金券支付部分)</p>
                </div>
            </div>
            <div class="item-row">
                <div>
                    <h5>￥{{tableData.all_driver_amount.total_self_amount}}</h5>
                    <p>余额支付(乘客自充支付部分)</p>
                </div>
                <div>
                    <h5>￥{{tableData.all_driver_amount.total_dd_amount}}</h5>
                    <p>三方-腾讯出行金额</p>
                </div>
                <div>
                    <h5>￥{{tableData.all_driver_amount.total_other_third_amount}}</h5>
                    <p>三方-其他金额</p>
                </div>
                <div>
                    <h5>￥{{tableData.all_driver_amount.total_group_amount}}</h5>
                    <p>集团账户金额</p>
                </div>
                <div>
                    <h5>￥{{tableData.all_driver_amount.total_third_amount}}</h5>
                    <p>不明来源订单金额(1)</p>
                </div>
            </div>

        </div>

        <div class="main thr">
            <div class="title">
                <h4>好易联清分金额</h4>
                <p>总金额 <span>￥{{tableData.total_online_recharge_amount}}</span> </p>
            </div>

            <div class="item-row">
                <div>
                    <h5>￥{{tableData.total_driver_recharge_amount}}</h5>
                    <p>司机充值总金额</p>
                </div>
                <div>
                    <h5>￥{{tableData.total_consumer_recharge_amount}}</h5>
                    <p>乘客充值总金额</p>
                </div>
                <div>
                    <h5>￥{{tableData.total_online_amount}}</h5>
                    <p>线上支付金额</p>
                </div>
                <div>
                    <h5>￥{{tableData.total_inspection_online_amount}}</h5>
                    <p>检车线上支付总金额</p>
                </div>
                <div>
                    <h5>￥{{tableData.total_all_legwork_amount}}</h5>
                    <p>跑腿支付金额</p>
                </div>
            </div>

        </div> -->

    </div>

</template>

<script>
    var _this;
    export default {


        data() {
            return {


                complete_fixed_time_value:"yesterday",
                //完成自定义时间
                complete_time_arrway: [],
                // 存放表格数据
                tableData: {},


                search_data: {
                    complete_fixed_array: ''
                },



            };
        },
        created() {
            _this = this;

            _this.searchgetFinancialAmount();
        },

        methods: {

            // 搜索时间选择触发
            timeChange(parm, val) {


                // console.log(_this.complete_time_arrway,'==============');

                _this.search_data.complete_fixed_array = JSON.stringify(["between"].concat(
                    _this.complete_time_arrway
                ))

            },
            // 搜索完成时间触发
            completeFixedTimeChange(val) {
                _this.complete_time_arrway = [];

                _this.search_data.complete_fixed_array = [];


                if (val == "between") {
                    _this.search_data.complete_fixed_array.push(
                        _this.complete_fixed_time_value
                    );
                } else if (val == "") {
                } else {
                    _this.search_data.complete_fixed_array.push(
                        _this.complete_fixed_time_value
                    );
                }
            },


            searchgetFinancialAmount() {

                if(_this.complete_fixed_time_value !='between'){
                    _this.search_data.complete_fixed_array = JSON.stringify([_this.complete_fixed_time_value]);
                }

                _this.getFinancialAmount();

            },
            // 搜索司机日志列表
            getFinancialAmount() {

                _this.$post(
                    "/statistics/getFinancialAmount",
                    _this.search_data
                ).then(res => {


                    _this.tableData = res.data;

                }).catch((err) => {

                })
            },
            //翻页组件的回调
            pages_function(search_data) {

                //赋值
                _this.search_data = search_data;
                //初始化列表
                _this.getFinancialAmount();

            },


            // 刷新按钮
            refresh() {
                this.$router.go(0);
            },

        }
    };
</script>

<style scoped>
    .main{
        width: 100%;
        border-radius: 10px;
        background: #FFFFFF;
        margin-bottom: 20px;
    }
    .main .title{
        display: flex;
        align-items: center;
        background-color: #90B0FA;
        border-radius: 10px 10px 0 0;
        padding-left: 30px;
        box-sizing: border-box;
    }
    .main.fir .title{
        background-color: #19C1E7;
    }
    .main.thr .title{
        background-color: #ff96aa;
    }
    .main .title h4{
        font-size: 18px;
        font-weight: 400;
        color: #FFFFFF;
        height: 80px;
        line-height: 80px;
        margin-right: 10%;
    }
    .main .title p{

        font-size: 14px;
        color: #FFFFFF;
        font-weight: 400;

    }
    .main .title p span{
        margin-left: 14px;
        display: inline-block;
        font-size: 26px;
        color: #FFFFFF;
        font-weight: 400;
    }
    .main .item-row{
        padding: 21px 17px;
        box-sizing: border-box;
        display: flex;
    }

    .main .item-row div{
        height: 110px;
        padding: 25px;
        box-sizing: border-box;
    }
    .main .item-row div h5{
        font-size: 18px;
        color: #505050;
        font-weight: 400;
    }
    .main .item-row div p{
        margin-top: 16px;
        font-size: 14px;
        color: #505050;
        font-weight: 400;
    }
    .main.fir .item-row div{
        width: 16.67%;
    }
    .main.sec .item-row div{
        width: 20%;
    }
    .main.thr .item-row div{
        width: 20%;
    }
    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }



    .el-form-item__content span {
        display: inline-block;
        width: 100%;
        word-wrap: break-word;
        white-space: normal;
    }
</style>
